"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcMeterConsumptions = exports.MeterConsumption = void 0;
const MeterConsumption_yaml_component_1 = __importDefault(require("./MeterConsumption.yaml?component"));
exports.MeterConsumption = MeterConsumption_yaml_component_1.default;
const UcMeterConsumptions_yaml_component_1 = __importDefault(require("./UcMeterConsumptions.yaml?component"));
exports.UcMeterConsumptions = UcMeterConsumptions_yaml_component_1.default;
